import { motion } from 'framer-motion';

export default function FinalCTA() {
  return (
    <section className="relative bg-navy-900 overflow-hidden py-24 md:py-32">
      <div className="absolute inset-0 bg-gradient-to-br from-navy-950 via-navy-900 to-navy-800" />

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {/* PLACEHOLDER: Once first named pilot clinic confirms, update the h2 to:
              "Trusted by [Clinic Name]. Now available to your practice."
              and add their city/specialty in the subline. */}
          <h2 className="text-4xl sm:text-5xl font-extrabold text-white tracking-tight leading-tight">
            Give your clinic time back.
          </h2>
          <p className="mt-5 text-lg text-white/55 max-w-xl mx-auto">
            Start a free 14-day trial with Aura-Chart — no credit card required. Or book a demo and we'll walk through it with your team.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://chromewebstore.google.com/detail/aura-chart/llkaecoefncjopopkbkhcmajliikeani"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold rounded-lg text-white bg-primary-600 hover:bg-primary-500 transition-colors shadow-lg shadow-primary-900/40 min-h-[52px]"
            >
              Start Free Trial
            </a>
            <a
              href="https://calendly.com/pulsestack1/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold rounded-lg text-white border border-white/25 hover:bg-white/10 transition-colors min-h-[52px]"
            >
              Book a Demo
            </a>
          </div>

          <p className="mt-6 text-sm text-white/30">
            Questions? Email{' '}
            <a href="mailto:contact@pulsestack.ai" className="underline hover:text-white/60 transition-colors">
              contact@pulsestack.ai
            </a>
          </p>
        </motion.div>
      </div>
    </section>
  );
}
